<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-input-container [hasError]="hasError" [hasShadow]="hasShadow" [class.disabled]="disabled">
  @if (!displayValue) {
    <mat-icon ngfPrefix inline class="search-icon">search</mat-icon>
  }

  @if (!displayValue) {
    <input
      #inputRef type="search" [formControl]="searchControl" [placeholder]="placeholder" (blur)="handleBlur()"
      [attr.aria-labelledby]="ariaLabelledby"
      role="combobox"
      aria-autocomplete="list"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
      [attr.aria-required]="isRequired || null"
      [attr.aria-describedby]="ariaDescribedby"
      [attr.aria-invalid]="hasError"
      aria-controls="options-container">
  }

  @if (displayValue) {
    <input
      #inputRef
      [value]="displayValue" readonly
      (keydown.backspace)="handleClear()"
      (keydown.delete)="handleClear()"
      (blur)="handleBlur()"
      [attr.aria-labelledby]="ariaLabelledby"
      [attr.aria-describedby]="selectedDescribedBy"
      [disabled]="disabled" ngfOverflow="ellipsis" [ngfOverflowTooltip]="displayValue" [ngfOverflowTooltipOnFocus]="false" [ngfOverflowTooltipDisabled]="!showOverflowTooltip"
      role="combobox"
      aria-autocomplete="list"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
      [attr.aria-required]="isRequired || null"
      aria-controls="options-container">
    @if (clearHint) {
      <span class="ngf-sr-only" [id]="clearHintId">{{ clearHint }}</span>
    }
  }

  @if (!!searchControl.value || displayValue) {
    <button
      ngfSuffix type="button" class="clear-btn"
      [attr.aria-label]="displayValue? 'Clear ' + displayValue : 'Clear ' + searchControl.value"
      (click)="handleClear()"
      (keydown.enter)="handleClear()"
      [disabled]="disableClear || disabled">
      @if (!disabled) {
        <mat-icon inline>clear</mat-icon>
      }
    </button>
  }

  <!-- Single root only: a second one (an &ngsp; sat here until FLO-54031) sends the button to the default slot, not [ngfSuffix]. -->
  @if (!displayValue) {
    <button
      ngfSuffix type="button" class="toggle-btn" tabindex="-1"
      [attr.aria-label]="isOpen ? 'Close options list' : 'Open options list'"
      (click)="handleToggle()"
      [disabled]="disabled">
      <mat-icon inline>{{isOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
    </button>
  }
</ngf-input-container>
